<template>
  <section class="create-merchant">
    <h1 class="create-merchant__title">Create Merchant Account</h1>
    <b-form>
      <div class="create-merchant__input-title">
        Business logo
      </div>
      <div class="create-merchant__input-sub-title">
        Add the logo of your business.
      </div>
      <b-img
        v-if="logo"
        :src="logo"
        rounded="circle"
        width="150"
        height="150"
        alt="img"
        class="create-merchant__logo" />
      <b-img
        v-else
        src="~@/assets/img/placeholder.jpg"
        rounded="circle"
        width="150"
        height="150"
        alt="img"
        class="create-merchant__logo" />
      <div class="create-merchant__add-logo">
        <label class="create-merchant__add-logo-button">
          Add logo
          <input
            type="file"
            @change="handleFileChange">
        </label>
      </div>
      <!--<div-->
      <!--v-if="validationErrors.logo"-->
      <!--class="create-merchant__error">{{ validationErrors.logo }}</div>-->
      <div
        v-if="showImageTypeMessage"
        class="create-merchant__error">{{ imageTypeMessage }}</div>
      <div class="create-merchant__input-title">
        Business name*
      </div>
      <div class="create-merchant__input-sub-title">
        Add the name of your business.
      </div>
      <b-input-group
        prepend="Business name*">
        <b-input
          v-model.trim="businessName"
          type="text"
          placeholder="Business inc"
          class="business-name"
          @blur.native="$v.businessName.$touch()"/>
      </b-input-group>
      <div
        v-if="validationErrors.businessName"
        class="create-merchant__error">{{ validationErrors.businessName }}</div>
      <div class="create-merchant__input-title">
        Domain name*
      </div>
      <div class="create-merchant__input-sub-title">
        Url for your AI Number account.
      </div>
      <b-input-group
        append="paybird.io"
        prepend="Domain name*">
        <b-input
          v-model.trim="domainName"
          type="text"
          placeholder="Domain name"
          class="business-name no-border-radius"
          @blur.native="$v.domainName.$touch()"/>
      </b-input-group>
      <div
        v-if="validationErrors.subdomain"
        class="create-merchant__error">{{ validationErrors.subdomain }}</div>
    </b-form>
    <div class="create-merchant__notes">(*) indicates required fields.</div>
    <b-button
      block
      class="create-merchant__submit"
      @click="goNext">Next</b-button>
    <b-button
      block
      class="create-merchant__submit--back"
      @click="goBack">Back</b-button>
  </section>
</template>

<script>
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'CreateMerchantStep2',
  props: {
    logop: {
      type: String,
      default: '',
    },
    businessNamep: {
      type: String,
      default: '',
    },
    domainNamep: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      logo: '',
      businessName: '',
      domainName: '',
      imageTypeMessage: 'Only .jpg, .jpeg, .png, .gif files allowed',
      showImageTypeMessage: false,
      validationErrors: {},
    };
  },
  computed: {
    // logoError() {
    //   if (!this.$v.logo.required && this.$v.logo.$dirty) {
    //     return 'Logo is required!';
    //   }
    //   return false;
    // },
    businessNameError() {
      if (!this.$v.businessName.required && this.$v.businessName.$dirty) {
        return 'Please enter business name.';
      }
      return false;
    },
    domainNameError() {
      if (!this.$v.domainName.required && this.$v.domainName.$dirty) {
        return 'Please enter domain name.';
      }
      return false;
    },
  },
  watch: {
    businessNameError(error) {
      this.validationErrors.businessName = error;
    },
    domainNameError(error) {
      this.validationErrors.subdomain = error;
    },
  },
  created() {
    if (this.logop.length) {
      this.logo = this.logop;
    }
    if (this.businessNamep.length) {
      this.businessName = this.businessNamep;
    }
    if (this.businessNamep.length) {
      this.domainName = this.domainNamep;
    }
  },
  methods: {
    handleFileChange(e) {
      // eslint-disable-next-line no-console
      // console.log(e.target.files);
      const file = e.target.files;
      if (file[0].type === 'image/png' ||
              file[0].type === 'image/gif' ||
              file[0].type === 'image/jpeg') {
        this.showImageTypeMessage = false;
        this.createImage(file[0]);
      } else {
        this.showImageTypeMessage = true;
      }
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    goBack() {
      this.$emit('goBack');
    },
    goNext() {
      const { logo, businessName, domainName } = this;
      const payload = {
        logo,
        businessName,
        domainName,
      };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$api('POST', '/validations/merchants/subdomain', { subdomain: payload.domainName })
          .then((response) => {
            if (response.status === 200) {
              this.$emit('goNext', payload);
            }
          })
          .catch((errors) => {
            this.validationErrors = setValidationErrors(errors.response.data.errors);
          });
      }
    },
  },
  validations: {
    // logo: {
    //   required,
    // },
    // businessName: {
    //   required,
    // },
    // domainName: {
    //   required,
    // },
  },
};
</script>
